export const selectTypeLabel = state => state.typeLabel;
